import React, { useState } from 'react';
import Sidebar from '../components/Sidebar';
import Navbar from '../components/Navbar';
import '../css/Sidebar.css';
import '../css/Navbar.css';
import '../css/Home.css';
import CurrentCars from '../components/CurrentCars';
import OrderedCars from '../components/OrderedCars';
import { FaSearch } from 'react-icons/fa';
import FilterSortModal from '../modal/FilterSortModal';
import { usePermissions } from '../hooks/usePermissions';



const Home = ({ isSidebarClosed, setIsSidebarClosed }) => {
  const [activeTab, setActiveTab] = useState('current');
  const [search, setSearch] = useState('');
  const [filterModalOpen, setFilterModalOpen] = useState(false);
  const [sort, setSort] = useState('abc');
  const { permissions } = usePermissions();

  const carView = [
    { key: 'current', label: 'Jelenlegi Autóim', component: CurrentCars },
    ...(permissions.can_see_ordered_cars ? [{ key: 'ordered', label: 'Megrendelt Autóim', component: OrderedCars }] : []),
  ];

  const ActiveComponent = carView.find(v => v.key === activeTab)?.component || CurrentCars;

  return (
    <div>
      <Navbar isSidebarClosed={isSidebarClosed} setIsSidebarClosed={setIsSidebarClosed} />
      <Sidebar isCollapsed={isSidebarClosed} setIsCollapsed={setIsSidebarClosed} />
      <div className="page-content">
        <div className="home-search-row">
          <input
            className="home-search-input"
            placeholder="Keresés..."
            value={search}
            onChange={e => setSearch(e.target.value)}
          />
          <button className="home-search-btn"><FaSearch /></button>
          <button className="home-filter-btn" onClick={() => setFilterModalOpen(true)}>Szűrés</button>
        </div>
        <div className="home-tabs">
          {carView.map((car) => (
            <span
              key={car.key}
              className={`home-tab${activeTab === car.key ? ' active' : ''}`}
              onClick={() => setActiveTab(car.key)}
            >
              {car.label}
            </span>
          ))}
        </div>
        <ActiveComponent search={search} sort={sort} />
        <FilterSortModal open={filterModalOpen} onClose={() => setFilterModalOpen(false)} sort={sort} setSort={setSort} />
      </div>
    </div>
  );
};

export default Home; 